import connect from './connect';

export { OrganizationInviteModal } from './OrganizationInviteModal';

export default connect;
